import logo from './images/logo.svg';
import logoSmall from './images/logo-small.svg';
import imgDarkWebEmail from './images/img-dark-web-email.svg';
import paymentRequired from './images/img_payment_required.svg';
import googlePay from './images/img_google_pay.svg';
import applePay from './images/img_apple_pay.svg';
import venmo from './images/img_venmo.svg';
import venmoButton from './images/img_venmo_button.svg';
import visa from './images/img_visa.svg';
import american_express from './images/img_amex.svg';
import discover from './images/img_discover.svg';
import genericCreditCard from './images/img_generic_credit_card.svg';
import paypal from './images/img_paypal.svg';
import masterCard from './images/img_mastercard.svg';
import pinterestLogo from './images/img_social_pinterest.svg';
import facebookLogo from './images/img_social_facebook.svg';
import instagramLogo from './images/img_social_instagram.svg';
import linkedinLogo from './images/img_social_linkedin.svg';
import facebookTwitter from './images/img_social_twitter.svg';
import imgExampleAircraft from './images/img_example_aircraft.svg';
import imgExampleAutomobile from './images/img_example_automobile.svg';
import imgExampleWatercraft from './images/img_example_watercraft.svg';
import imgMonitoringBell from './images/img_bell_monitoring.svg';
import imgIdHub from './images/id-hub.svg';
import imgAddressGeneric from './images/img_address_generic_no_bg.svg';
import imgSpecializedBackgroundCheck from './images/specialized-background-check.svg';
import imgSpecializedUnclaimedMoney from './images/specialized-unclaimed-money.svg';
import imgReportRating from './images/img_report_rating.svg';
import imgSuccessfulUpgrade from './images/img_successful_upgrade.svg';
import img24hr from './images/img_24hr.svg';
import img_pdf_glow from './images/img_pdf_glow.svg';
import neighborSpoofing from './images/neighbor-spoofing.svg';
import imgNoProperty from './images/no-property-img-fallback.svg';
import imgMonitorBanner from './images/img_neighborhood_safety.svg';
import imgNHFacts from './images/img_neighborhood_facts.svg';
import imgMarketTrends from './images/img_market_trends.svg';
import imgAmenities from './images/img_amenities.svg';
import imgAnimatedPersonMagnifying from './images/ani_person_magnifying.gif';
import imgMagnifyingGlassNoResultsPage from './images/img_magnifying_glass_no_results.svg';
import imgWhatIsAVin from './images/img_what_is_a_vin.svg';
import imgWhereIsVin from './images/img_where_is_vin.svg';
import imgCheckList from './images/icn_img_checklist.svg';
import imgAppStoreBadge from './images/img_apple_app_store_badge.svg';
import imgGooglePlayBadge from './images/img_badge_google_play.svg';
import imgMobileFreemium from './images/img_mobile_freemium.svg';
import imgContactlessIcon from './images/img_contactless_icon.svg';
import imgCopyIcon from './images/img_copy_icon.svg';
import imgEtagsLogo from './images/img_etags_logo.svg';
import imgMobileExpIcon from './images/img_mobile_exp_icon.svg';
import imgUpdatesIcon from './images/img_updates_icon.svg';
import imgCircleUser from './images/img_circle_user.svg';
import imgSeverityCritical from './images/severity-critical.svg';
import imgSeverityHigh from './images/severity-high.svg';
import imgSeverityLow from './images/severity-low.svg';
import imgSeverityMedium from './images/severity-medium.svg';
import imgSeverityNone from './images/severity-none.svg';
import imgSafety from './images/safety.svg';
import imgCampaign from './images/campaign.svg';
import imgClock from './images/clock.svg';
import imgDollar from './images/dollar.svg';
import imgEmission from './images/emission.svg';
import imgPremiumBadge from './images/img_premium_badge.svg';
import imgTitleRegistration from './images/img_title_registration.svg';
import imgTitleChecks from './images/img_title_checks.svg';
import accidentsCoverageMapImage from './images/accident_coverage_map.png';
import rewardsBannerMobile from './images/rewards_banner_mobile.png';
import rewardsBannerDesktop from './images/rewards_banner_desktop.png';
import imgNMVTISLogo from './images/img_nmvtis_logo.svg';
import imgNoVehicleImageProvided from './images/no-vehicle-image-provided.svg';
import imgExpiredEmailLink from './images/img_expired_email_link.svg';
import imgMyGarageBrake from './images/img_mygarage_brake.svg';
import imgMyGarageOilChange from './images/img_mygarage_oilchange.svg';
import imgMyGarageSellYourCar from './images/img_mygarage_sellyourcar.svg';
import imgMyGarageStar from './images/img_mygarage_starfilled.svg';
import imgMyGarageTireChange from './images/img_mygarage_tirechange.svg';
import imgMyGarageTitleCheck from './images/img_mygarage_titlecheck.svg';
import imgAddVehicle from './images/add-vehicle.svg';
import imgFallbackSexOffender from './images/img_placeholder_sex_offender.svg';
import { CustomIcons, Icons, ReportTypeOption } from '@ltvco/refresh-lib';
import ComplianceLogo from './images/img-alert.svg';
import SearchLogo from './images/search-logo.svg';
import imgCustomerService from './images/img_customer_service.svg';
import myGarageCtaImage from './images/my_garage_cta_image.svg';
import rewardsCtaImage from './images/rewards_cta_image.svg';
import imgMapBoxPin from './images/img_pin.svg';
import imgAreaPin from './images/img_areapin.svg';
import imgDarkWebScan from './images/img_dark_web_scan.svg';
import imgSearch from './images/img_search.svg';
import imgContactHours from './images/img_contact_hours.svg';
import imgBellMonitoring from './images/img_bell_monitoring.svg';
import imgHeadset from './images/img_headset.svg';
import imgMobileApp from './images/img_mobile_app.svg';
import imgReportChecked from './images/img_report_checked_logo.svg';
import firstRewardBanner from './images/sirius_xm_banner.png';
import imgReferralsIcon from './images/img_referrals_icon.svg';
import imgOnlineMarketplaceIcon from './images/img_online_marketplace_icon.svg';
import imgDealersIcon from './images/img_dealers_icon.svg';
import imgServiceCenterIcon from './images/img_service_center_icon.svg';
import imgFleetOwnersIcon from './images/img_fleet_owners_icon.svg';
import imgAuctioneersIcon from './images/img_auctioneers_icon.svg';
import imgRadialCar from './images/img-radial-car.svg';
import imgComputerLimitReached from './images/img_computer_limit_reached.svg';
import imgPremiumFrame from './images/img-premium-frame.svg';
import imgPremiumSearchIcon from './images/img-premium-search-icon.svg';
import imgCheckIcon from './images/img-check-icon.svg';
import imgCloseIcon from './images/img-close-icon.svg';
import vehiclePictureBookImg from 'images/vehicle-story-book.png';
import storyBookChapter1Img from 'images/story-book-chapter-1.png';
import storyBookChapter2Img from 'images/story-book-chapter-2.png';
import storyBookChapter3Img from 'images/story-book-chapter-3.png';
import chapter1Icon from 'images/chapter-1-icon.png';
import chapter2Icon from 'images/chapter-2-icon.png';
import chapter3Icon from 'images/chapter-3-icon.png';
import chapter1Corner from 'images/chapter-1-corner.png';
import chapter2Corner from 'images/chapter-2-corner.png';

const baseUrl = `${window.location.protocol}//${window.location.host}`;
const reportTypeFilterOptions: { [key: string]: ReportTypeOption } = {
  vehicle_report: {
    id: 'vehicle_report',
    display: 'Vehicle',
    eventLabel: 'Vehicle',
  },
};

// TODO: should we extend the default config the same way we're doing with the theme? might be good for some props, other props maybe should be required
export const constants = {
  images: {
    brandLogo: logo,
    brandLogoMobile: logoSmall,
    master: masterCard,
    visa: visa,
    american_express: american_express,
    discover: discover,
    genericCreditCard: genericCreditCard,
    paypal: paypal,
    googlePay: googlePay,
    paymentRequired: paymentRequired,
    applePay: applePay,
    venmo: venmo,
    venmoButton: venmoButton,
    searchLogo: SearchLogo,
    complianceLogo: ComplianceLogo,
    imgDarkWebEmail: imgDarkWebEmail,
    imgNoProperty,
    imgExampleAircraft: imgExampleAircraft,
    imgExampleWatercraft: imgExampleWatercraft,
    imgExampleAutomobile: imgExampleAutomobile,
    monitoringBell: imgMonitoringBell,
    imgIdHub,
    imgAddressGeneric,
    imgDarkWebScan,
    imgSpecializedBackgroundCheck,
    imgSpecializedUnclaimedMoney,
    imgReportRating: imgReportRating,
    imgSuccessfulUpgrade: imgSuccessfulUpgrade,
    imgComputerLimitReached: imgComputerLimitReached,
    pdfLogo: img_pdf_glow,
    img24hr,
    neighborSpoofing,
    imgAnimatedPersonMagnifying,
    imgMagnifyingGlassNoResultsPage: imgMagnifyingGlassNoResultsPage,
    imgMonitorBanner: imgMonitorBanner,
    imgMobileExpIcon: imgMobileExpIcon,
    imgCopyIcon: imgCopyIcon,
    imgContactlessIcon: imgContactlessIcon,
    imgUpdatesIcon: imgUpdatesIcon,
    imgEtagsLogo: imgEtagsLogo,
    imgAddVehicle: imgAddVehicle,
    imgNHFacts: imgNHFacts,
    imgMarketTrends: imgMarketTrends,
    imgAmenities: imgAmenities,
    imgWhatIsAVin: imgWhatIsAVin,
    imgWhereIsVin: imgWhereIsVin,
    imgCheckList,
    imgAppStoreBadge,
    imgGooglePlayBadge,
    imgMobileFreemium,
    ownershipHistoryImages: {
      imgCircleUser,
    },
    recallImages: {
      imgSeverityCritical,
      imgSeverityHigh,
      imgSeverityLow,
      imgSeverityMedium,
      imgSeverityNone,
      imgClock,
      imgDollar,
      imgEmission,
      imgSafety,
      imgCampaign,
    },
    imgPremiumBadge,
    imgTitleRegistration,
    imgTitleChecks,
    accidentsCoverageMapImage,
    rewardsBannerMobile,
    rewardsBannerDesktop,
    myGarageCtaImage,
    rewardsCtaImage,
    imgFallbackSexOffender,
    imgMapBoxPin,
    imgAreaPin,
    imgReferralsIcon,
    imgCustomerService,
    imgExpiredEmailLink,
    imgNoVehicleImageProvided,
    imgMyGarage: {
      imgMyGarageBrake: imgMyGarageBrake,
      imgMyGarageOilChange: imgMyGarageOilChange,
      imgMyGarageSellYourCar: imgMyGarageSellYourCar,
      imgMyGarageStar: imgMyGarageStar,
      imgMyGarageTireChange: imgMyGarageTireChange,
      imgMyGarageTitleCheck: imgMyGarageTitleCheck,
    },
    nmvtisLogo: imgNMVTISLogo,
    imgSearch,
    imgContactHours,
    imgHeadset,
    imgBellMonitoring,
    imgMobileApp,
    instructionalVideoMobile: 'https://via.placeholder.com/80x40',
    instructionalVideoDesktop: 'https://via.placeholder.com/80x40',
    imgReportChecked,
    firstRewardBanner,
    imgApiSolutions: {
      imgOnlineMarketplaceIcon,
      imgDealersIcon,
      imgServiceCenterIcon,
      imgFleetOwnersIcon,
      imgAuctioneersIcon,
    },
    imgRadialCar,
    imgPremiumData: {
      imgPremiumFrame,
      imgPremiumSearchIcon,
      imgCheckIcon,
      imgCloseIcon,
    },
    vehiclePictureBookImg,
  },
  links: {
    baseUrl: `${baseUrl}${
      import.meta.env.VITE_PATH_PREFIX?.includes('/')
        ? import.meta.env.VITE_PATH_PREFIX
        : `/${import.meta.env.VITE_PATH_PREFIX}`
    }`,
    joinLink: 'https://www.bumper.com/lp/114010/4/subscribe',
    brandLink: import.meta.env.VITE_DEV_PROXY_SEARCH_PERSON_TEASER
      ? ''
      : `${baseUrl}`,
    aboutLink: 'https://www.bumper.com/about/',
    fcraLink: '',
    doDontsLink: '',
    tosLink: 'https://www.bumper.com/terms/',
    privacyLink: 'https://www.bumper.com/privacy-policy/',
    contactLink: 'https://www.bumper.com/contact/',
    FaqLink: '',
    dontSellInfoLink: 'https://www.bumper.com/app/optout/search',
    affiliateLink: 'https://www.beenverified.com/affiliates',
    peopleSearchLink: '',
    reversePhoneLink: '',
    emailLookupLink: '',
    reverseAddressLink: '',
    contactForm: 'https://www.bumper.com/contact/',
    supportLink: 'https://support.bumper.com',
    twitterLink: 'https://x.com/bumperdotcom',
    facebookLink: 'https://www.facebook.com/Bumperdotcom',
    blogLink: 'https://www.bumper.com/blog/',
    brandIosUrl: 'https://bumperapp.onelink.me/Cl4S/e7cbad2',
    brandAndroidUrl: 'https://play.google.com/store/apps/details?id=com.bumper',
    rapidsLookupLink: `${baseUrl}/rpds/lookup`,
    etagsPartnerUrl: 'https://www.etags.com/app/us?whitelabel=bumper',
    mrRogersBaseUrl: '/ss/mrg',
    billingLink: 'https://support.bumper.com/hc/en-us',
    customPlanLink: 'https://forms.gle/MjUT6rfPWGh9NCTb7',
    mapboxStyleUrl: '',
    dataDeckRootURI: 'hk/dd/v2',
    marketplaceBaseUrl: 'https://www.bumper.com/marketplace/',
    accidentDisclaimerURL:
      'https://support.bumper.com/hc/en-us/articles/12017018227867',
    chatLink: 'https://www.bumper.com/chat/',
    vehicleReportInquiryURL:
      'https://www.bumper.com/contact/vehicle-history-report-inquiry/',
    nmvtisGlossaryURL: 'https://vehiclehistory.bja.ojp.gov/nmvtis_glossary',
    nmvtisStatesURL: 'https://vehiclehistory.bja.ojp.gov/nmvtis_states',
    nmvtisDataProvidersURL:
      'https://vehiclehistory.bja.ojp.gov/nmvtis_vehiclehistory',
    nmvtisVehicleHistoryURL: 'http://vehiclehistory.bja.ojp.gov/',
    topHapBaseUrl: 'https://widgets.tophap.com/api/widgets',
    fairCreditReportingActLink: '',
    partnerProgramLink: 'https://forms.gle/MsshKYQfoMsdmP459',
    reactivateLink: 'https://bumper.com/rf/reactivation',
  },
  featureFlags: {
    hasCriminalEnabled: false,
    hasVINScannerEnabled: true,
    hasSmartInsightsAutoLoadEnabled: true,
    propertyReportFlags: ['include_ca_data'],
    notificationsDisabled: true,
  },
  data: {
    brandName: 'Bumper',
    brandAbbreviation: 'bp' as 'bp',
    // we need to send it empty locally to enable the search person teaser proxy
    brandSupportEmail: 'support@bumper.com',
    legalName: 'Bumper, LLC',
    supportPhone: '1-332-225-9745',
    customerSupportPhone: '1-888-579-5910',
    supportEmail: 'support@bumper.com',
    complianceEmail: 'compliance@bumper.com',
    pdfPrice: '$4.95',
    rewardsDisclaimer:
      'Certain products and services, including vehicle purchase/sale opportunities, provided above include offers from third parties and/or external partners from whom we may receive limited compensation. Please be advised that these offers are provided as a convenience and are a sample, but do not necessarily include ALL offers, products or services available in the marketplace.',
    rewardsDescription:
      "As a Bumper member, you can take advantage of benefits and perks that can help you save time and money throughout your car buying, owning and selling journey. With Bumper, find awesome savings for all your vehicle needs: from used car pre-purchase inspections to auto insurance, even when you need service or maintenance. Check back often as we add more savings - we're just getting started!",
    searchTabsReplacementText: 'History Reports',
    carGeniusPhone: '1-877-313-2578',
    vehiclePictureBook: [
      {
        image: storyBookChapter1Img,
        chapterIcon: chapter1Icon,
        cornerIcon: chapter1Corner,
        chapterTitle: 'Learn about its past',
        chapterDescription:
          "Discover the origins of a vehicle and when it hit the road. In a Bumper report, you could learn about significant events about a vehicle's journey.",
        primaryAction: { text: 'Next Page', action: 'next' as 'next' },
      },
      {
        image: storyBookChapter2Img,
        chapterIcon: chapter2Icon,
        cornerIcon: chapter2Corner,
        chapterTitle: 'Explore with curiosity',
        chapterDescription:
          'Use our Table of Content menu to help you switch between different sections of the report. Use our various tools inside the report to help with researching a vehicle.',
        primaryAction: { text: 'Next Page', action: 'next' as 'next' },
        secondaryAction: { text: 'Back', action: 'previous' as 'previous' },
      },
      {
        image: storyBookChapter3Img,
        chapterIcon: chapter3Icon,
        chapterTitle: 'Beyond the vehicle report',
        chapterDescription:
          "Every road leads to new adventures. Equip yourself with new knowledge about a vehicle's past. Use our 'Monitor' feature along with other on the top menu to help you stay up to date.",
        primaryAction: { text: 'Close', action: 'close' as 'close' },
        secondaryAction: { text: 'Back', action: 'previous' as 'previous' },
      },
    ],
  },
  config: {
    socialMedia: [
      {
        textContent: 'Twitter',
        alternateTextContent: '@bumperdotcom',
        href: 'https://x.com/bumperdotcom',
        imgLogoUrl: facebookTwitter,
        icon: <CustomIcons.TwitterIcon sx={{ color: 'primary' }} />,
        hideOnSide: false,
      },
      {
        textContent: 'Facebook',
        alternateTextContent: 'facebook.com/bumperdotcom',
        href: 'https://www.facebook.com/bumperdotcom',
        imgLogoUrl: facebookLogo,
        icon: <Icons.Facebook fontSize="small" color="primary" />,
        hideOnSide: false,
      },
      {
        textContent: 'Instagram',
        alternateTextContent: 'instagram.com/bumperdotcom',
        href: 'https://www.instagram.com/bumperdotcom',
        imgLogoUrl: instagramLogo,
        icon: <Icons.Instagram fontSize="small" color="primary" />,
        hideOnSide: false,
      },
      {
        textContent: 'Linkedin',
        href: 'https://www.linkedin.com/company/bumperdotcom',
        imgLogoUrl: linkedinLogo,
        icon: <Icons.LinkedIn fontSize="small" color="primary" />,
        hideOnSide: true,
      },
      {
        textContent: 'Pinterest',
        href: 'https://www.pinterest.com/bumperdotcom',
        imgLogoUrl: pinterestLogo,
        hideOnSide: true,
      },
      {
        textContent: 'Bumper Blog',
        href: 'https://www.bumper.com/blog/',
        imgLogoUrl: logoSmall,
        hideOnSide: true,
      },
    ],
    searchTabs: [
      {
        displayName: 'Vehicle',
        id: 'vehicleTab',
        icon: <Icons.DirectionsCar fontSize="small" color="primary" />,
        class: '',
      },
    ],
    sideMenuItems: [
      {
        route: 'https://www.bumper.com/marketplace/',
        icon: <Icons.Sell color="primary" />,
        text: 'Marketplace',
        state: '',
        name: 'marketplace',
        openInNewTab: true,
      },
      {
        route: '/dashboard/home',
        icon: <Icons.DirectionsCar color="primary" />,
        text: 'My Bumper',
        name: 'myBumper',
        state: '',
        'data-cy': 'dashboard',
      },
      {
        route: '/dashboard/rewards',
        icon: <Icons.Redeem color="primary" />,
        text: 'Rewards',
        state: '',
        name: 'rewards',
      },
      {
        route: '/dashboard/reports',
        icon: <Icons.Restore color="primary" />,
        text: 'Recent Reports',
        name: 'recentReports',
        state: '',
        'data-cy': 'recent_reports',
      },
      {
        route: '/dashboard/lists',
        icon: <Icons.List color="primary" />,
        text: 'Saved Reports and Lists',
        state: '',
        name: 'lists',
        'data-cy': 'saved_reports_and_list',
      },
      {
        route: '/dashboard/api',
        icon: <Icons.Code color="primary" />,
        text: 'Bumper API',
        state: '',
        name: 'api',
      },
      {
        route: '/dashboard/monitoring',
        icon: <Icons.NotificationsNone color="primary" />,
        text: 'Monitoring',
        state: '',
        name: 'monitoring',
      },
      {
        route:
          'https://chrome.google.com/webstore/detail/save-cars-across-many-sit/ddcabilfaldblnbjjdakdhdkggmncplh?source=rf',
        icon: <CustomIcons.GoogleChromeIcon width="24px" height="24px" />,
        text: 'Chrome Extension',
        state: '',
        name: 'chromeExtension',
        'data-cy': 'chrome_extension',
        openInNewTab: true,
      },
      {
        route: 'https://www.bumper.com/tools/compare-cars/',
        icon: <Icons.CompareArrows color="primary" />,
        text: 'Compare Vehicles',
        state: '',
        name: 'compare',
        openInNewTab: true,
      },
      {
        route: '/dashboard/billing',
        icon: <Icons.AccountCircle color="primary" />,
        text: 'My Account',
        state: '',
        name: 'myAccount',
        'data-cy': 'my_account',
      },
      {
        route: '/dashboard/referrals',
        icon: <Icons.PersonAdd color="primary" />,
        text: 'Send Invite',
        state: '',
        name: 'referrals',
      },
    ],
    reportTypeFilterOptions,
    higherConfidenceThreshold: 50,
    hardcodedPlans: [],
  },
  keys: {
    rapidsAPIKey: '2skFtN2m6NrKMZnUG8Q4',
    mapboxKey:
      'pk.eyJ1IjoiYmVlbnZlcmlmaWVkIiwiYSI6ImNqeXN3ejY2MDAwbXczaHFzcnp6cmo5eGUifQ.hEfUf5T6xAzgW8wghHulEA',
    mrRogersAPIKey: 'kl6x16zhIp39hszFhGt5cxAfDV1MoXId',
    streetViewStaticApiKey: 'AIzaSyA6H5JZT4MeOKS_JUzBmtBC-wCsvDqIm40',
    topHapApiKey: 'si_MKritZu1BytMaH',
    carwiserToken: 'zLPenm4kT2xCFg9mNU',
  },
};
